export default "__VITE_PUBLIC_ASSET__105abf7b__"